module.exports = __webpack_public_path__ + "img/busstop.ae1dddc8.png";